import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
    iconPack: 'fontawesome'
})
// options to the toast
let error_options = {
    type: 'error',
    theme: "bubble",
    icon: {
        name: "fa-exclamation-triangle"
    },
    position: "top-right",
    action: {
        text: 'Close',
        class: 'text-red-lightest font-bold',
        onClick: (e, toastObject) => {
            toastObject.goAway(0);
        }
    },
};

Vue.toasted.register('calc_error',
    (payload) => {

        // if there is no message passed show default message
        let defaultMessage = 'Oops..Something Went Wrong! ';

        return `${payload.mainMessage ? payload.mainMessage : defaultMessage}
        ${payload.additionalMessage ? payload.additionalMessage : ''}
        ${((process.env.MIX_APP_ENV == 'local' || process.env.MIX_APP_ENV == 'development') && _.get(payload, 'error.response.data.message')) ? '</br>' + payload.error.response.data.message : ''}`;
    },
    error_options
)

let success_options = {
    type: "success",
    theme: "bubble",
    icon: {
        name: "fa-check-circle"
    },
    position: "top-right",
    duration: 5000
};

Vue.toasted.register('calc_success',
    (payload) => {
        let defaultMessage = 'Success! ';

        return `${payload.mainMessage ? payload.mainMessage : defaultMessage}
        ${payload.additionalMessage ? payload.additionalMessage : ''}`;
    },
    success_options
)